import axios from "axios";
import { BASE_URL, IMG_PREFIX } from "@/config";
import { getToken, removeToken } from "./qwLogin";
import { toast } from "vue3-toastify"; // 引入toast组件

const service = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// 请求拦截器（可加 token、loading 等）
service.interceptors.request.use(
  (config) => {
    // TODO: 可以加 token，loading 等
    config.headers.Authorization = getToken();
    return config;
  },
  (error) => {
    // 请求错误处理
    if (!navigator.onLine) {
      console.error("网络异常，请检查网络后重试");
    } else {
      console.error("请求错误：", error);
    }
    return Promise.reject(error);
  }
);

// 响应拦截器（自动拼接图片地址）
service.interceptors.response.use(
  (response) => {
    const res = response.data;

    // 如果有列表且含图片字段，自动拼接前缀
    if (Array.isArray(res.list)) {
      res.list = res.list.map((item) => {
        if (item.broadcast_image && !item.broadcast_image.startsWith("http")) {
          item.broadcast_image = IMG_PREFIX + item.broadcast_image;
        }
        return item;
      });
    }

    if (res.broadcast_image) {
      res.broadcast_image = IMG_PREFIX + res.broadcast_image;
      // console.log('请求成功hhhh：', res.broadcast_image);
    }

    return res;
  },
  (error) => {
    // 响应错误处理
    if (!navigator.onLine) {
      console.error("网络异常，请检查网络后重试");
    } else if (error.code === "ECONNABORTED") {
      console.error("网络异常，请检查网络后重试");
    } else if (
      error.status === 401 &&
      !error.config.url.includes("reservation/status")
    ) {
      toast("登录已过期，请重新登录");
      removeToken();
    } else if (error.response) {
      console.error(
        "服务器响应错误：",
        error.response.status,
        error.response.data
      );
    } else {
      console.error("请求错误：", error.message);
    }
    return Promise.reject(error);
  }
);

export default service;
